import styles from './CaseStudyCard.module.css';

interface CaseStudyCardProps {
  industry: string;
  title: string;
  summary: string;
  result?: string;
  statValue?: string;
  statLabel?: string;
}

export function CaseStudyCard({ industry, title, summary, result, statValue, statLabel }: CaseStudyCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.meta}>
        <span className={styles.industryTag}>{industry}</span>
        {result && <span className={styles.resultTag}>{result}</span>}
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.summary}>{summary}</p>
      {statValue && statLabel && (
        <div className={styles.stat}>
          <span className={styles.statValue}>{statValue}</span>
          <span className={styles.statLabel}>{statLabel}</span>
        </div>
      )}
    </div>
  );
}
